import { render, staticRenderFns } from "./CampoHorario.vue?vue&type=template&id=0be9e9dc&scoped=true"
import script from "./CampoHorario.vue?vue&type=script&lang=js"
export * from "./CampoHorario.vue?vue&type=script&lang=js"
import style0 from "./CampoHorario.vue?vue&type=style&index=0&id=0be9e9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9e9dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VMenu,VTextField,VTimePicker})
